/** Polyfill not implement ec spec case for an empty search value case 'abc'.replaceAll("", "t") -> tatbtct */
if (!String.prototype.replaceAll) {
  Object.defineProperty(String.prototype, 'replaceAll', {
    value: function (searchValue, replaceValue) {
      const str = String(this);

      if (searchValue instanceof RegExp) {
        if (!searchValue.global) {
          throw new TypeError('replaceAll must be called with a global RegExp');
        }

        return str.replace(searchValue, replaceValue);
      }

      const searchStr = String(searchValue);

      const escaped = searchStr.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

      const regex = new RegExp(escaped, 'g');

      return str.replace(regex, replaceValue);
    },
    writable: true,
    configurable: true,
  });
}
